(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoCUService', ReporteEvaluativoCUService);

    ReporteEvaluativoCUService.$inject = ['$resource'];

    function ReporteEvaluativoCUService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/reporteCU:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
//            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreportecu:id',
            	method:'PUT' 
            },
            'save': {
            	url:'apo/guardarreportecu:id',
            	method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getRevision': {
            	url:'apo/revisionreportecu:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'ver': {
            	url:'apo/verreportecu:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();